//  Encapsulates the javascript logic for the Cobalt navigation editor, which uses js to enable drag reordering of the navigation links
(function ($, Cobalt, undefined) {
    Cobalt.NavigationEditor = function (listSelector, roles) {
        this.navList = $(listSelector);
        this.errorCssClass = 'vld-error';
        this.nextRow = 1;
        this.linkRegex = new RegExp("^((https?:\/\/([-\w]+)(\.\w+)+(:\d+)?)|\/)");
        this.roleList = roles;
        this.linkSelectorID;

        // Add a new input line
        this.addInputLine = function (name, css, link, roleIDs, moduleLinkID, pageID, nonremovable, parentNavID, newTab, childPartialView, filterID) {
            var nav = this;
            var li = $("<li>").attr("id", this.nextRow);
            var table = li.append($("<table>"));
            var row = table.append("<tr>");
            row.append($("<td class=\"col-drag\"><a href=\"#\" class=\"icon icon-drag-handle\">Drag</a></td>"));
            var nameInput = $("<input type='text' size='32'>").attr("id", "name" + this.nextRow).attr("name", "name" + this.nextRow).val(name);
            row.append($("<td class='col-label'>").append(nameInput));

            if (parentNavID) {
                row.addClass("sub-nav");
            }

            var cssInput = $("<input type='text' size='48'>").attr("id", "css" + this.nextRow).attr("name", "css" + this.nextRow).val(css);
            row.append($('<td class="col-css">').append(cssInput));



            var linkInput = $("<input type='text' size='48'>").attr("id", "link" + this.nextRow).attr("name", "link" + this.nextRow).val(link);
            if (moduleLinkID || pageID || filterID) {
                linkInput.attr("disabled", "true");
            }
            var linkCol = $("<td class='col-link'>").append(linkInput);
            linkCol.append($("<input>").attr('type', 'hidden').attr('id', 'nav' + this.nextRow).attr('name', 'nav' + this.nextRow));

            if (moduleLinkID) {
                var linkInputName = 'linkID' + this.nextRow;
                nameInput.attr('disabled', 'true');
                linkCol.append($("<input>").addClass('linkID').attr('type', 'hidden').attr('id', linkInputName).attr('name', linkInputName).val(moduleLinkID));
            }
            else if (pageID) {
                var pageInputName = 'pageID' + this.nextRow;
                linkCol.append($("<input>").addClass('pageID').attr('type', 'hidden').attr('id', pageInputName).attr('name', pageInputName).val(pageID));
            }
            else if (filterID) {
                var filterInputName = 'filterID' + this.nextRow;
                nameInput.attr('disabled', 'true');
                linkInput.attr('disabled', 'true');
                linkCol.append($("<input>").addClass('filterID').attr('type', 'hidden').attr('id', filterInputName).attr('name', filterInputName).val(filterID));
            }
            row.append(linkCol);

            var childPartialViewInput = $("<input type='text' size='24'>").attr("id", "child-partial-view" + this.nextRow).attr("name", "child-partial-view" + this.nextRow).val(childPartialView);
            row.append($('<td class="col-child-partial-view">').append(childPartialViewInput));

            var newTabInput = $("<input>").attr("type", "checkbox").attr("id", "new" + this.nextRow).attr("name", "new" + this.nextRow);
            if (newTab == "True") {
                newTabInput.attr("checked", "checked");
            }
            row.append($("<td class='col-new'>").append(newTabInput));

            /* Role Selector */
            var roleSelector = $("<div>").attr("class", "role-selector").attr("id", "roleID" + this.nextRow);
            var displayRoleSelector = false;

            /* Visibility Selector */
            var visibilitySelector = $("<select>").attr("class", "visibility-selector");
            var publicOption = $("<option>");
            publicOption.val("Public");
            publicOption.text("Public");
            var privateOption = $("<option>");
            privateOption.val("Rank Protected");
            privateOption.text("Rank Protected");
            if (roleIDs != null && roleIDs.length > 0) {
                privateOption.attr("selected", "selected");
            }
            else {
                publicOption.attr("selected", "selected");
            }
            visibilitySelector.append(publicOption);
            visibilitySelector.append(privateOption);

            if (this.roleList) {
                for (var i = 0; i < this.roleList.length; i++) {
                    /* Container */
                    var container = $("<div>").attr("class", "role-container");

                    /* Checkbox */
                    var input = $("<input>").attr("type", "checkbox").attr("id", "roleID" + this.nextRow).attr("name", "roleID" + this.nextRow);
                    input.val(this.roleList[i].ID);
                    if (roleIDs != null && $.inArray(this.roleList[i].ID, roleIDs) > -1) {
                        input.attr("checked", "checked");
                        displayRoleSelector = true;
                    }
                    container.append(input);

                    /* Label */
                    var label = $("<label>").attr("for", "roleID" + this.nextRow);
                    label.append(this.roleList[i].Name);
                    container.append(label);

                    /* Append container to Role Selector */
                    roleSelector.append(container);
                }
            }

            visibilitySelector.change(function () {
                var option = visibilitySelector.val();
                if (option == "Public") {
                    roleSelector.attr("style", "display:none;");
                    var inputs = $(roleSelector).find(":input");
                    for (var i = 0; i < inputs.length; i++) {
                        inputs.attr("checked", false);
                    }
                }
                else {
                    roleSelector.attr("style", "");
                }
            });

            if (!displayRoleSelector) {
                roleSelector.attr("style", "display:none;");
            }
            row.append($("<td class='col-role'>").append(visibilitySelector).append(roleSelector));

            if (parentNavID) {
                this.appendHiddenParentIDField(row, parentNavID, this.nextRow);
            }

            if (nonremovable == 'true') {
                row.append($("<td class='col-actions'>"));
                roleSelector.disable();
            } else {
                var tooltip = Cobalt.Localization.Main.Global.ControlPanel.RemoveLinkTooltip();
                var link = $("<a>").addClass("icon").addClass("delete").addClass("tip").attr("title", tooltip);
                var cell = $("<td>").addClass("col-actions");
                cell.append(link);
                if (!parentNavID) {
                    tooltip = Cobalt.Localization.Main.Global.ControlPanel.AddSubNavigationLink();
                    link = $("<a>").addClass("icon").addClass("add").addClass("tip").attr("title", tooltip);
                    cell.append(" ").append(link);
                }
                row.append(cell);

                if (parentNavID == undefined) {
                    row.find(".add").click(function () {
                        if (nav.linkSelectorID) {
                            var linkID = $(this).parent().parent().attr("id");
                            if (linkID) {
                                nav.addInputLine('', '', '', '', '', '', '', linkID, false);
                            }
                        }
                    });
                }

                row.find(".delete").click(function () {
                    if (nav.linkSelectorID) {
                        var linkID = $(this).parent().parent().find('.linkID').val();
                        if (linkID) {
                            $('#' + nav.linkSelectorID + ' option[data-modulelinkid=' + linkID + ']').enable();
                        }
                        var pageID = $(this).parent().parent().find('.pageID').val();
                        if (pageID) {
                            $('#' + nav.linkSelectorID + ' option[data-pageid=' + pageID + ']').enable();
                        }
                        var filterID = $(this).parent().parent().find('.filterID').val();
                        if (filterID) {
                            $('#' + nav.linkSelectorID + ' option[data-filter-id=' + filterID + ']').enable();
                        }
                    }
                    var row = $(this).parent().parent();

                    var subNavRows = row.siblings("tr.sub-nav").find(":hidden[value='" + row.attr("id") + "']").parents("tr.sub-nav");
                    subNavRows.remove();
                    row.remove();
                });
            }
            if (parentNavID) {

                var parentItem = this.navList.find
                var childContainer = this.navList.find("ul[data-parent-id='" + parentNavID + "']");
                
                var rowToAddAfter = $(tableId).find(":hidden[value=\"" + parentNavID + "\"]").last().parents("tr#" + parentNavID);
                if (rowToAddAfter.length <= 0) {
                    rowToAddAfter = $(tableId).find("tr[id='" + parentNavID + "']");
                }
                rowToAddAfter.after(row);
            }
            else {
                this.navList.append(li);
            }
            this.nextRow++;
            Cobalt.triggerHtmlInsert(row);
        }

        this.appendHiddenParentIDField = function (row, parentNavID, rowNum) {
            var parentNavField = $("<input>").attr("type", "hidden").attr("value", parentNavID).attr("name", "sub-nav" + rowNum).addClass("sub-nav-parent-field");
            row.find(":hidden.sub-nav-parent-field").remove();
            row.append(parentNavField);
            $("#" + parentNavID).addClass("has-sub-nav");
        }

        this.initialize = function () {
            $(listSelector).nestedSortable(
            {
                disableNesting: 'no-nest',
                forcePlaceholderSize: true,
                handle: 'div.drag-handle .icon-drag-handle',
                items: '>tbody>tr',
                opacity: .6,
                placeholder: 'placeholder',
                tabSize: 25,
                tolerance: 'pointer',
                stop: function (e, ui) {
                    var dragged = $(ui.item);
                    if (dragged.length > 0) {

                    }
                }
            });
        };

        // Must be called any time a new row is added
        this.enableDragging = function (draggingEnabled) {
            var nav = this;
            if (draggingEnabled == null) {
                draggingEnabled = true;
            }
            if (draggingEnabled) {

                $(tableId).tableDnD({
                    onDragClass: "dragHandle",
                    onDrop: function (table, rowDropped) {
                        rowDropped = $(rowDropped);
                        table = $(table);
                        var rowsArray = new Array();
                        table.find("tbody").children().each(function (i, val) { rowsArray.push($(val)); });
                        if (rowDropped.hasClass("sub-nav")) {
                            var parentRow = $("tr#" + rowDropped.find(":hidden.sub-nav-parent-field").val());
                            var rowDroppedIndex = -1;
                            var parentRowIndex = -1;
                            for (var i = 0; i < rowsArray.length; i++) {
                                if ($(rowsArray[i]).attr("id") == rowDropped.attr("id")) {
                                    rowDroppedIndex = i;
                                    continue;
                                }

                                if ($(rowsArray[i]).attr("id") == parentRow.attr("id")) {
                                    parentRowIndex = i;
                                    continue;
                                }
                            }

                            if (rowDroppedIndex < parentRowIndex) {
                                parentRow.after(rowDropped);
                            }
                        }
                    },
                    onDragStart: function (table, row) {
                        row = $(row);
                        table = $(table);
                        if (row.hasClass("sub-nav")) {
                            var parentRowID = row.find(":hidden.sub-nav-parent-field").val();
                            var parentRow = table.find("tr#" + parentRowID);
                            table.find("tbody").children().addClass("nodrop");
                            table.find(":hidden.sub-nav-parent-field[value=\"" + parentRowID + "\"]").each(function (i, val) {
                                $(val).parent().removeClass("nodrop");
                            });
                        }
                        else {
                            table.find("tr :hidden.sub-nav-parent-field").parent().addClass("nodrop");
                            $("tr :hidden.sub-nav-parent-field").each(function (i, val) {
                                $("tr#" + $(val).val()).addClass("nodrop");
                            });
                        }
                    },
                    onAllowDrop: function (draggedRow, dropRow) {
                        var row = $(draggedRow);
                        if (row.hasClass("has-sub-nav")) {
                            if ($(dropRow).hasClass("sub-nav")) {
                                return false;
                            }
                            var rowID = row.attr("id");
                            $(":hidden.sub-nav-parent-field[value='" + rowID + "']").each(function (i, val) {
                                var childRow = $(val).parent();
                                row.after(childRow);
                            });
                        }
                        return true;
                    }
                });
                $(tableId + " tbody tr").hover(function () {
                    $(this.cells[0]).addClass('showDragHandle');
                }, function () {
                    $(this.cells[0]).removeClass('showDragHandle');
                });
            }
        }

        // Bind to a dropdown containing predefined navigation options
        this.bindBuiltInLinkSelector = function (selectId) {
            var nav = this;
            nav.linkSelectorID = selectId;
            $('#' + selectId).change(function () {
                if (this.options[this.selectedIndex].value != 'null') {
                    var url = this.options[this.selectedIndex].value;
                    var moduleLinkId = this.options[this.selectedIndex].getAttribute('data-modulelinkid');
                    var pageId = this.options[this.selectedIndex].getAttribute('data-pageid');
                    var nonremovable = this.options[this.selectedIndex].getAttribute('data-nonremovable');
                    var filterID = this.options[this.selectedIndex].getAttribute('data-filter-id');

                    nav.addInputLine(this.options[this.selectedIndex].text, '', url == '' ? '/' : url, null, moduleLinkId, pageId, nonremovable, '', false, null, filterID);
                    //nav.enableDragging();
                    this.options[this.selectedIndex].disabled = 'disabled';
                }
                this.selectedIndex = 0;
            });
        }

        // Bind to a button for adding blank lines
        this.bindAddLineButton = function (buttonId) {
            var nav = this;
            $('#' + buttonId).click(function (e) {
                nav.addInputLine('', '', '');
                //nav.enableDragging();
                e.preventDefault();
            });
        }
        // Bind to a button for adding blank lines
        this.bindAddSeparatorButton = function (buttonId) {
            var nav = this;
            $('#' + buttonId).click(function () {
                nav.addInputLine('--', '', '-------------------------');
                //nav.enableDragging();
            });
        }
        // Bind to submit button for client side validation
        this.bindSubmitButton = function (buttonId) {
            var nav = this;
            $('#' + buttonId).click(function () {
                var valid = true;
                $('td.link input').each(function () {
                    var url = $(this).val();
                    if (url != '' && !nav.linkRegex.test(url)) {
                        $(this).addClass('vld-error');
                        valid = false;
                    } else {
                        $(this).removeClass(nav.errorCssClass);
                    }
                });
                $('td.label input').each(function () {
                    if ($(this).val() == '') {
                        $(this).addClass(nav.errorCssClass);
                        valid = false;
                    } else {
                        $(this).removeClass(nav.errorCssClass);
                    }
                });
                return valid;
            });
        }

    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NavigationEditor.js